function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Lightning Icon");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M10.5103583,1.82603642 C10.6731393,1.56895203 10.683086,1.24355707 10.5361674,0.977126497 C10.3897915,0.710978765 10.109611,0.545454545 9.80553158,0.545454545 L5.1852302,0.545454545 C4.86930143,0.545454545 4.58068273,0.723831259 4.43915957,1.00619437 L0.107380245,9.66975245 C-0.0219925526,9.92761683 -0.00802155721,10.2348175 0.143734721,10.4807741 C0.296705884,10.7272746 0.564565517,10.8769664 0.853687082,10.8769664 L3.00159824,10.8769664 L0.0847220025,17.804578 C-0.0748891567,18.1848042 0.0667645315,18.6244141 0.417852727,18.8396413 C0.550438899,18.9207093 0.700773075,18.9625023 0.85338252,18.9625023 C1.09729498,18.9625023 1.33115808,18.855942 1.49114794,18.6666892 L10.7324566,7.69263878 C10.9416142,7.44430697 10.9872202,7.09749267 10.8506384,6.80343668 C10.7135502,6.5090735 10.4187685,6.32085665 10.0943237,6.32085665 L7.66352664,6.32085665 L10.5103583,1.82603642 Z M1.7458237,16.6706623 L4.32580579,10.5431785 L4.64459226,9.7860573 L1.26890072,9.7860573 L5.34374808,1.63636364 L9.33918143,1.63636364 L6.21159941,6.57445639 L5.68128259,7.41176574 L9.54279072,7.41176574 L1.7458237,16.6706623 Z",
  id: "lightning-path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "lightning-Icon/Global/Autobook",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "lightning-Swatches/Midnight",
  transform: "translate(6.000000, 2.000000)"
}, /*#__PURE__*/React.createElement("use", {
  id: "lightning-Mask",
  fill: "currentcolor",
  fillRule: "nonzero",
  xlinkHref: "#lightning-path-1"
})));

var SvgLightning = function SvgLightning(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLightning, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lightning.56a5af63.svg";
export { ForwardRef as ReactComponent };